(() => {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('.birdy-page').forEach(page => {
      if (page.dataset.birdyReady === 'true') return;
      page.dataset.birdyReady = 'true';
      const cards = [...page.querySelectorAll('.product-card')];
      const buttons = [...page.querySelectorAll('[data-filter]')];
      function filter(value) {
        cards.forEach(card => { card.hidden = value !== 'all' && card.dataset.finish !== value; });
        buttons.forEach(button => { const active = button.dataset.filter === value; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
        const counter = page.querySelector('.finish-count');
        if (counter) counter.textContent = cards.filter(card => !card.hidden).length + ' 商品';
      }
      buttons.forEach(button => button.addEventListener('click', () => filter(button.dataset.filter)));
      filter('all');
      page.querySelectorAll('[data-birdy-purchase]').forEach(holder => {
        const form = holder.querySelector('.product-single__form');
        const variants = form && form.querySelector('[data-product-select]');
        if (variants) {
          variants.setAttribute('aria-label', '商品の種類');
          variants.addEventListener('change', () => {
            if (!/^\d+$/.test(variants.value)) return;
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variants.value);
            window.location.assign(url.toString());
          });
        }
        if (form && window.theme && theme.settings.cartType === 'dropdown' && typeof theme.AjaxProduct === 'function') new theme.AjaxProduct(form, '.add-to-cart');
        const pickup = holder.querySelector('[data-store-availability-holder]');
        if (pickup && holder.dataset.birdySelectedVariant && window.theme && typeof theme.StoreAvailability === 'function') new theme.StoreAvailability(pickup).updateContent(holder.dataset.birdySelectedVariant);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
